import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core";
import CustomDialog, { CustomDialogProps } from "../../../components/Dialog/CustomDialog";
import { ProductContext } from "../../../contexts/ProductContext";
import { TesaPrototype } from "../../../api/models/product/TesaPrototype";
import PrototypeSampleAddForm from "./PrototypeSampleAddForm";
import PrototypeSampleAddFormType from "../../../api/models/product/PrototypeSampleAddFormType";
import { Laboratory } from "../../../api/models/product/Laboratory";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      marginBottom: theme.spacing(5),
    },
  }),
);

const ProductSampleAddPrototypeDialog = (props: CustomDialogProps) => {
  const { open, onClose } = props;
  const classes = useStyles();

  const submitForm = (
    prototype: TesaPrototype,
    updatePrototypeObject: (newPrototype: TesaPrototype) => void,
    updateLaboratoryObject: (newLaboratory: Laboratory) => void,
  ): void => {
    updatePrototypeObject(prototype);
    if (prototype.responsibleLaboratory) {
      updateLaboratoryObject(prototype.responsibleLaboratory);
    }
    onClose(true);
  };

  return (
    <ProductContext.Consumer>
      {(productContext) => {
        const { updatePrototypeObject, updateLaboratoryObject } = productContext;

        return (
          <CustomDialog fullWidth maxWidth="sm" onClose={() => onClose(false)} open={open}>
            <h2 className={classes.header}>ADD TESA PROTOTYPE</h2>
            <PrototypeSampleAddForm
              handleSubmit={(values: PrototypeSampleAddFormType) => {
                if (values.prototype) {
                  submitForm(values.prototype, updatePrototypeObject, updateLaboratoryObject);
                }
              }}
            />
          </CustomDialog>
        );
      }}
    </ProductContext.Consumer>
  );
};

export default ProductSampleAddPrototypeDialog;
